import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { AuthenticationService } from '@core/auth/authentication.service';
import { FormService } from '@core/services/form.service';
import { NotificationService } from '@core/services/notification.service';
import { CapituloService } from '@modules/capitulo/capitulo.service';
import { QtCaracteresSinopseModalComponent } from '@modules/capitulo/components/qt-caracteres-sinopse-modal/qt-caracteres-sinopse-modal.component';
import { aplicarTrim } from '@shared/util/util';
import dayjs from 'dayjs';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { combineLatest } from 'rxjs';

interface Lista {
  name: string;
  itens: ItemLista[];
}

interface ItemLista {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnChanges {

  @ViewChild('formElement') formElement!: ElementRef;

  @Output() dynamicFormSubmit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() dynamicFormComFormElemtentSubmit = new EventEmitter<{ form: FormGroup, formElement: ElementRef }>();
  @Output() dynamicFormReset: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormCancell: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormAdicionarItemCena: EventEmitter<number> = new EventEmitter<number>();
  @Output() dynamicFormAdicionarTodosCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormReaproveitarCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormCadastrarNovoCena: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormAprovarSinopses: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormGerarRelatorioSinopses: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormReprovarSinopses: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() dynamicFormGerarSinopses: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  dynamicForm!: FormGroup;
  @Input() formName: any;
  @Input() fields: any[] = [];
  @Input() lists: any[] = [];
  @Input() rowClass!: string;
  @Input() border: boolean = false;
  @Input() formType: FormTypeEnum = FormTypeEnum.Filter;
  @Input() acao!: RouteAction;
  @Input() isCena: boolean = false;
  @Input() isReaproveitar: boolean = false;
  @Input() isSelecionarTodos: boolean = false;
  @Input() isShowActive: boolean = false;
  @Input() model: any;
  @Input() itensSelecionadosEnviado: any;

  optionValueFn: string = 'id';
  optionLabelFn: string = 'descricao';

  sortedFields: any[] = [];

  typeField = TypeFieldEnum;
  typeFieldEnum = TypeFieldEnum;
  formTypeEnum = FormTypeEnum;
  routeActionEnum = RouteAction;
  visualizar: any;

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private notificationService: NotificationService,
    private router: Router,
    private modalService: NzModalService,
    private service: CapituloService,
    private authenticationService: AuthenticationService
  ) {
    this.verificarAcaoAtual();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fields'] || changes['lists']) {
      this.sortedFields = this.sortFields(this.fields);
      this.dynamicForm = this.createDynamicForm(this.sortedFields);

      if (this.isCena && !this.sortedFields[0].nzBlur) {
        this.dynamicForm.controls['select']?.valueChanges.subscribe(val => {
          if (val) {
            this.dynamicFormAdicionarItemCena.emit(val);
          }
        });
      }
      if (this.formName === 'relatorios-personagem-roupa' || this.formName === 'relatorios-figurante-roupa') {
        const campoAte = this.dynamicForm.get('numeroCapituloAte');
        const campoTipoRelatorio = this.dynamicForm.get('tipoRelatorio');
        const campoComFoto = this.dynamicForm.get('comFoto');
        
        combineLatest([
          campoTipoRelatorio!.valueChanges,
          campoComFoto!.valueChanges
        ]).subscribe(([tipoRelatorio, comFoto]) => {
          const isAnaliticoComFoto = (tipoRelatorio === 1 || tipoRelatorio?.id === 1) && comFoto?.id === 1;        
          
          campoAte?.[isAnaliticoComFoto ? 'disable' : 'enable']();
          if (isAnaliticoComFoto) campoAte?.reset();
        });
      }

      if (this.formName === 'relatorios-pedido-roupa') {
        this.dynamicForm.get('comFoto')?.valueChanges.subscribe((comFoto: any) => {
          const roteiroAte = this.dynamicForm.get('numeroRoteiroAte');
        
          if (comFoto?.id !== 2) {
            roteiroAte?.reset();
            roteiroAte?.disable();
          } else {
            roteiroAte?.enable();
          }
        });
      }

      if (this.model) {
        this.applyModelToForm();
      }

      this.aplicarDadosSessionStorage();
    }

    if (changes['model'] && this.dynamicForm) {
      if (this.model) {
        this.applyModelToForm();
      }
    }

    if(this.formName == 'relatorios-roteiro') {
      const tipoRelatorioId = { id: 1 };
      const ordenacaoId = { id: 1 };
      this.dynamicForm.get('tipoRelatorio')?.setValue(tipoRelatorioId);
      this.dynamicForm.get('ordenacao')?.setValue(ordenacaoId);
    }

    if(this.formName == 'relatorios-roteiro-continuidade') {
      const tipoRelatorioId = { id: 1 };
      const ordenacaoId = { id: 1 };
      this.dynamicForm.get('tipoRelatorio')?.setValue(tipoRelatorioId);
      this.dynamicForm.get('ordenacao')?.setValue(ordenacaoId);
    }

    if(this.formName == 'relatorios-personagem-roupa') {
      const indCaminhoRoupa = { id: 1 };
      const indObsCena = { id: 1 };
      const comRoupa = { id: 2};
      this.dynamicForm.get('indCaminhoRoupa')?.setValue(indCaminhoRoupa);
      this.dynamicForm.get('indObsCena')?.setValue(indObsCena);
      this.dynamicForm.get('comFoto')?.setValue(comRoupa);
    }

    if(this.formName == 'relatorios-figurante-roupa') {
      const indCaminhoRoupa = { id: 1 };
      const indObsCena = { id: 1 };
      const comRoupa = { id: 2};
      this.dynamicForm.get('indCaminhoRoupa')?.setValue(indCaminhoRoupa);
      this.dynamicForm.get('indObsCena')?.setValue(indObsCena);
      this.dynamicForm.get('comFoto')?.setValue(comRoupa);
    }

    if(this.formName == 'relatorios-pedido-roupa') {
      const comRoupa = { id: 2};
      this.dynamicForm.get('comFoto')?.setValue(comRoupa);
    }
  }

  applyModelToForm(): void {
    if (this.dynamicForm.controls && this.lists.length) {
      const convertModelIds = (model: any) => {
        for (const key in model) {
          if (model.hasOwnProperty(key)) {
            const value = model[key];
            if (typeof value === 'object' && value !== null && 'id' in value) {
              model[key] = value.id;
            }
          }
        }
      };

      convertModelIds(this.model);
      this.dynamicForm.patchValue(this.model);

      if (this.visualizar) {
        this.dynamicForm.disable()
      }
    }
  }

  sortFields(fields: any[]): any[] {
    return fields.slice().sort((a, b) => a.order - b.order);
  }

  createDynamicForm(fields: any[]) {
    const formGroup = this.formBuilder.group({});

    fields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      formGroup.addControl(field.name, this.formBuilder.control(null, validators));
    });

    return formGroup;
  }

  onSubmit() {
    const messages = this.formService.getValidationsMessages(this.dynamicForm, this.formElement);
    this.formService.validateAllFormFields(this.dynamicForm);

    if (messages.length) {
      this.notificationService.warn('Os seguintes campos abaixo devem ser preenchidos corretamente:', this.formService.createValidationList(messages));
      return;
    }

    if (this.dynamicForm.valid) {
      aplicarTrim(this.dynamicForm);

      const dynamicFormEnvio = new FormGroup({});
      Object.keys(this.dynamicForm.controls).forEach(key => {
        const control = this.dynamicForm.get(key);
        if (control instanceof FormGroup) {
          dynamicFormEnvio.addControl(key, new FormGroup({ ...control.controls }));
        } else if (control instanceof FormArray) {
          dynamicFormEnvio.addControl(key, new FormArray([...control.controls]));
        } else {
          dynamicFormEnvio.addControl(key, new FormControl(control?.value, control?.validator));
        }
      });

      this.convertFormDates(dynamicFormEnvio);

      const relatorio = this.formName?.includes('relatorios');
      (relatorio || this.formType == FormTypeEnum.Submit)
        ? this.dynamicFormComFormElemtentSubmit.emit({ form: dynamicFormEnvio, formElement: this.formElement })
        : this.dynamicFormSubmit.emit(dynamicFormEnvio)
    } else {
      this.notificationService.error('Atenção', 'Existem campos obrigatórios a serem preenchidos.');
    }
  }

  reset() {
    this.dynamicForm.reset();
    this.dynamicFormReset.emit(true);
  }

  back() {
    this.dynamicFormCancell.emit(true);
  }

  getFieldList(fieldName: string) {
    const field = this.fields.find(f => f.name === fieldName);

    if (field.type == TypeFieldEnum.Select || field.type == TypeFieldEnum.SelectMultiple) {
      if (!field || !this.lists) {
        return [];
      }
      const list = this.lists.find(itens => itens.name == field.list);
      return list ? list.itens : [];
    }
    return []
  }

  getOptionValue(item: any, optionValueFn?: string): any {
    optionValueFn = optionValueFn ?? 'id';
    return optionValueFn == 'item' ? item : item[optionValueFn];
  }

  getOptionLabel(item: any, optionLabelFn?: string): any {
    optionLabelFn = optionLabelFn ?? 'descricao';
    return optionLabelFn == 'item' ? item : item[optionLabelFn];
  }

  selecionarTodos() {
    this.dynamicFormAdicionarTodosCena.emit(true);
  }

  reaproveitar() {
    this.dynamicFormReaproveitarCena.emit(true);
  }

  cadastrarNovo() {
    this.dynamicFormCadastrarNovoCena.emit(true);
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }

  convertFormDates(form: FormGroup) {
    const stringDatas = ['dataCadastro', 'dataInicio', 'dataFim', 'dataGravacao', 'dataGravacaoDe', 'dataGravacaoAte'];

    Object.keys(form.controls).forEach(key => {
      if (stringDatas.includes(key)) {
        const control = form.get(key);
        if (control && control.value) {
          control.setValue(dayjs(control.value).format('YYYY-MM-DD'));
        }
      }
    });
  }

  verificarAcaoAtual() {
    this.visualizar = this.router.url.includes('visualizar');
  }

  reportSinopse() {
    const dadosUser = this.authenticationService.currentUserValue;
    const produtoAtualId = dadosUser?.produto?.id ?? null;

    const capitulos = this.itensSelecionadosEnviado || null;
    
    const objEnvio = {
      "numerosCapitulos": this.itensSelecionadosEnviado,
      "produtoId": produtoAtualId,
      "ativo": true,
      // "situacaoSinopse": "Aprovado",
      
    }

    this.service.exportSinopses(objEnvio).subscribe({
      next: (res: any) => {
        this.notificationService.success('Sucesso!', 'Exportação de sinopses feita com sucesso');
      },
      error: (error: any) => {
        this.notificationService.error('Erro!', 'Ocorreu um erro ao exportar as sinopses. Por favor, tente novamente.');
      }
    });
  }

  reportSinopseXLSX() {
    const dadosUser = this.authenticationService.currentUserValue;
    const produtoAtualId = dadosUser?.produto?.id ?? null;

    const capitulos = this.itensSelecionadosEnviado || null;
    
    const objEnvio = {
      "numerosCapitulos": this.itensSelecionadosEnviado,
      "produtoId": produtoAtualId,
      "ativo": true,
      // "situacaoSinopse": "Aprovado",
      
    }

    this.service.exportSinopsesXLSX(objEnvio).subscribe({
      next: (res: any) => {
        this.notificationService.success('Sucesso!', 'Exportação de sinopses feita com sucesso');
      },
      error: (error: any) => {
        this.notificationService.error('Erro!', 'Ocorreu um erro ao exportar as sinopses. Por favor, tente novamente.');
      }
    });
  }

  aprovarTodos() {
    const dadosUser = this.authenticationService.currentUserValue;
    const produtoAtualId = dadosUser?.produto?.id ?? null;

    const listaCapitulos = this.itensSelecionadosEnviado.map((numero: number) => ({
      numero_capitulo: numero,
      produto_id: produtoAtualId,
      status_sinopse: "Aprovada"
    }));
    
    const objEnvio = {
      "numeros_capitulos": this.itensSelecionadosEnviado,
      "produto_id": produtoAtualId,
      "user_login": dadosUser?.login,
      "capitulos": listaCapitulos
      
    }
    this.service.reviewSynopsis(objEnvio).subscribe((res: any) => {
      this.notificationService.success('Sucesso!', 'Sinopses aprovadas com sucesso');
      
    })

  }

  reprovarTodos() {
    const dadosUser = this.authenticationService.currentUserValue;
    const produtoAtualId = dadosUser?.produto?.id ?? null;

    const listaCapitulos = this.itensSelecionadosEnviado.map((numero: number) => ({
      numero_capitulo: numero,
      produto_id: produtoAtualId,
      status_sinopse: "Reprovada",
      justificativa_reprovacao: "Reprovada"
    }));
    
    const objEnvio = {
      "numeros_capitulos": this.itensSelecionadosEnviado,
      "produto_id": produtoAtualId,
      "user_login": dadosUser?.login,
      "capitulos": listaCapitulos
      
    }
    this.service.reviewSynopsis(objEnvio).subscribe((res: any) => {
      this.notificationService.success('Sucesso!', 'Sinopses reprovadas com sucesso');
      
    })

  }

  gerarTodos() {
    this.dynamicFormGerarSinopses.emit(true);
  }

  gerarSinopse() {
    const config: ModalOptions<QtCaracteresSinopseModalComponent> = {
      nzTitle: 'Quantidade máxima de caracteres da sinopse',
      nzContent: QtCaracteresSinopseModalComponent,
      nzWidth: '30vw',
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: false,
    }
    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.regerar = true;
    modalRef.componentInstance!.itensSelecionados = this.itensSelecionadosEnviado;
    modalRef.afterClose.subscribe((res) => {
      if (res) {
        if(!res.itensSelecionados || res.itensSelecionados.length == 0) {
          this.notificationService.error('Erro!', 'Selecione pelo menos um capítulo!');

        } else {
          this.gerarSinopseCallback(res)
        }
      }
    })
  }

  gerarSinopseCallback(res: any) {
    const dadosUser = this.authenticationService.currentUserValue;
    const produtoAtualId = dadosUser?.produto?.id ?? null;

    const caracteres: { [key: string]: any } = {};

    res.itensSelecionados.forEach((numero: number) => {
      caracteres[`${numero}`] = res.qtd;
    });
  
    if (produtoAtualId) {
      const objEnvio = {
        "numeros_capitulos": res.itensSelecionados,
        "produto_id": produtoAtualId,
        "user_login": dadosUser?.login,
        "caracteres": caracteres
      }

      this.service.generateSynopsis(objEnvio).subscribe((res: any) => {
        this.notificationService.success('Sucesso!', 'Sinopse gerada com sucesso');
        
      })
    } else {
      this.notificationService.error('Erro!', 'Atualize a tela e tente novamente!');
    }

  }

  onDropdownOpenChange(isOpen: any, fieldName: string) {
    if (!isOpen) {
      const lista = this.dynamicForm.get(fieldName)?.value;
      this.dynamicFormAdicionarItemCena.emit(lista);
    }
  }

  onDropdownOpenChangeFigurante(isOpen: any, fieldName: string) {
    if (!isOpen) {
      const lista = this.dynamicForm.get(fieldName)?.value;
      this.dynamicFormAdicionarItemCena.emit(lista);
    }
  }

  private aplicarDadosSessionStorage(): void {
    // const dadosSalvos = sessionStorage.getItem('filtro');
  
    // if (dadosSalvos && this.dynamicForm) {
    //   const formData = JSON.parse(dadosSalvos);
    //   const formPatch: any = {};
  
    //   Object.keys(formData).forEach(key => {
    //     if (this.dynamicForm.contains(key)) {
    //       formPatch[key] = formData[key];
    //     }
    //   });
  
    //   this.dynamicForm.patchValue(formPatch);

    //   const isEquipe = this.router.url.includes('equipe');
    //   if(!isEquipe) {
    //     setTimeout(() => this.onSubmit(), 200);
    //   }
    // }
    const filtroRaw = sessionStorage.getItem('filtro');

    if (!filtroRaw) return;
  
    const filtroSalvo = JSON.parse(filtroRaw);
    const urlAtual = this.router.url.split('?')[0].split('/editar')[0];
  
    if (filtroSalvo.url !== urlAtual) {
      sessionStorage.removeItem('filtro');
      return;
    }
  
    const formData = filtroSalvo.data;
    const formPatch: any = {};
  
    Object.keys(formData).forEach(key => {
      if (this.dynamicForm.contains(key)) {
        formPatch[key] = formData[key];
      }
    });
  
    this.dynamicForm.patchValue(formPatch);
    
    const isEquipe = this.router.url.includes('equipe');
    if(!isEquipe) {
      setTimeout(() => this.onSubmit(), 200);
    }
  }
}

export enum TypeFieldEnum {
  Input = 'input',
  Select = 'select',
  SelectMultiple = 'selectMultiple',
  TextArea = 'textArea',
  DatePicker = 'datePicker',
  InputGroup = 'InputGroup',
  InputNumber = 'number',
}

export enum FormTypeEnum {
  Filter = 'filter',
  Submit = 'submit'
}
